import { SupportTopic } from '@yoweb/types/enums';

type Emails = {
  support: string;
  partner: string;
  press: string;
  urgent: string;
};

const LOCALE_TO_EMAILS: Record<string, Emails> = {
  'en-us': {
    support: 'support@yohana.com',
    partner: 'partner@yohana.com',
    press: 'press@yohana.com',
    urgent: 'urgent@yohana.com',
  },
  'ja-jp': {
    support: 'support@yohana.jp',
    partner: 'partner@yohana.jp',
    press: 'press@yohana.jp',
    urgent: 'urgent@yohana.jp',
  },
};

export const createSupportEmails = (locale: string) => {
  const emails = LOCALE_TO_EMAILS[locale.toLowerCase()];

  if (!emails) {
    throw new Error(`Provided a locale that is unsupported: ${locale}`);
  }

  return emails;
};

export const createSupportTopicsEmailMap = (locale: string): { [key in SupportTopic]: string } => {
  const supportEmails = createSupportEmails(locale);

  return {
    [SupportTopic.EXISTING_MEMBERSHIP]: supportEmails.support,
    [SupportTopic.MEMBERSHIP_WAITLIST]: supportEmails.support,
    [SupportTopic.YO_APP]: supportEmails.support,
    [SupportTopic.BILLING_PURCHASES_ACCOUNT]: supportEmails.support,
    [SupportTopic.PARTNER_AFFILIATE]: supportEmails.partner,
    [SupportTopic.PRESS]: supportEmails.press,
    [SupportTopic.URGENT]: supportEmails.urgent,
  } as const;
};
